export { default as ModalDeleteAdmin } from './ModalDelete/ModalDeleteAdmin';
export { default as ModalDeleteAuthor } from './ModalDelete/ModalDeleteAuthor';
export { default as ModalInsight } from './ModalInsight';
export { default as ModalLike } from './ModalLike';
export { default as ModalLinkPost } from './ModalLinkPost';
export { default as ModalReport } from './ModalReport';
export { default as ModalTipping } from './ModalTipping';
